import React, { useEffect, useState, createElement, Component } from 'react';
import { HeroSection } from '../components/SalesLetter/HeroSection';
import { MicroRecipes } from '../components/SalesLetter/MicroRecipes';
import { ValueStack } from '../components/SalesLetter/ValueStack';
import { Testimonials } from '../components/SalesLetter/Testimonials';
import { Guarantee } from '../components/SalesLetter/Guarantee';
import { UrgencySection } from '../components/SalesLetter/UrgencySection';
import { ObjectionFAQ } from '../components/SalesLetter/ObjectionFAQ';
import { FinalClose } from '../components/SalesLetter/FinalClose';
import { AuthorSection } from '../components/SalesLetter/AuthorSection';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, CheckCircle2, Zap } from 'lucide-react';
// Flash Sale Banner Component (30 min countdown at top)
function FlashSaleBanner() {
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 47 * 60 + 33); // 2h 47m 33s
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-[#C1440E] text-white py-2.5 px-4 sticky top-0 z-50 shadow-md" data-id="element-442">
      <div className="max-w-3xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-bold" data-id="element-443">
        <Zap className="w-4 h-4 md:w-5 md:h-5 text-yellow-300 fill-yellow-300 animate-pulse flex-shrink-0" data-id="element-444" />
        <span className="uppercase tracking-wide" data-id="element-445">Flash Sale</span>
        <span className="hidden md:inline" data-id="element-446">—</span>
        <span className="text-yellow-200" data-id="element-447">Oferta termina en:</span>
        <span className="bg-white/20 px-2 py-0.5 rounded font-mono tabular-nums tracking-wider" data-id="element-448">
          {String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:
          {String(seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}
// Social Proof Popup Component (bottom-left toast every 30s)
function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const messages = [{
    name: 'María',
    time: '3 min'
  }, {
    name: 'Roberto',
    time: '7 min'
  }, {
    name: 'Ana',
    time: '12 min'
  }, {
    name: 'Carlos',
    time: '15 min'
  }, {
    name: 'Sofía',
    time: '22 min'
  }, {
    name: 'Luis',
    time: '28 min'
  }, {
    name: 'Patricia',
    time: '5 min'
  }, {
    name: 'Diego',
    time: '9 min'
  }];
  useEffect(() => {
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 5000);
    // Then show every 30 seconds
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % messages.length);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const current = messages[currentIndex];
  return <AnimatePresence data-id="element-449">
      {visible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed bottom-6 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-200 p-4 max-w-[280px]" data-id="element-450">
          <div className="flex items-center gap-3" data-id="element-451">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-452">
              <CheckCircle2 className="w-5 h-5 text-green-600" data-id="element-453" />
            </div>
            <div data-id="element-454">
              <p className="text-sm font-bold text-[#2C1810]" data-id="element-455">
                {current.name} compró el botiquín
              </p>
              <p className="text-xs text-gray-500" data-id="element-456">hace {current.time}</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
// Sticky Bottom CTA Component
function StickyBottomCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-457">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 z-50 md:hidden" data-id="element-458">
          <div className="flex items-center justify-between gap-4" data-id="element-459">
            <div data-id="element-460">
              <p className="text-xs text-gray-500 line-through" data-id="element-461">$19.97</p>
              <p className="text-xl font-bold text-[#C1440E]" data-id="element-462">$6.97</p>
            </div>
            <button onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-[#C1440E] text-white px-6 py-3 rounded-lg font-bold text-sm flex items-center gap-2 shadow-lg animate-pulse" data-id="element-463">
              COMPRAR AHORA <ArrowRight className="w-4 h-4" data-id="element-464" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}
export function SalesPage() {
  // Meta Pixel initialization
  useEffect(() => {
    // Load Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1584241515962496');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1584241515962496&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-[#FDF8F0] font-sans text-[#2C1810] overflow-x-hidden" data-id="element-465">
      <FlashSaleBanner data-id="element-466" />
      <HeroSection data-id="element-467" />
      <MicroRecipes data-id="element-468" />
      <AuthorSection data-id="element-469" />
      <div id="offer" data-id="element-470">
        <ValueStack data-id="element-471" />
      </div>
      <Testimonials data-id="element-472" />
      <Guarantee data-id="element-473" />
      <UrgencySection data-id="element-474" />
      <FinalClose data-id="element-475" />
      <ObjectionFAQ data-id="element-476" />

      <StickyBottomCTA data-id="element-477" />
      <SocialProofPopup data-id="element-478" />

      {/* Footer simple */}
      <footer className="bg-[#2C1810] text-[#FDF8F0]/60 py-12 text-center text-sm" data-id="element-479">
        <div className="max-w-3xl mx-auto px-6" data-id="element-480">
          <p className="mb-4 font-medium" data-id="element-481">
            © 2026 Tu Botiquín Natural. Todos los derechos reservados.
          </p>
          <p className="text-xs max-w-lg mx-auto opacity-70 leading-relaxed" data-id="element-482">
            Este producto no sustituye el consejo médico profesional. Si tienes
            condiciones preexistentes graves, consulta a tu médico antes de
            iniciar cualquier protocolo natural. Los resultados pueden variar de
            persona a persona.
          </p>
        </div>
      </footer>
    </div>;
}